import { render, staticRenderFns } from "./EditWorkerModal.vue?vue&type=template&id=be7769fc"
import script from "./EditWorkerModal.vue?vue&type=script&lang=js"
export * from "./EditWorkerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports